import {connect} from 'formik'
import { Popover } from 'shared'

import itzLogo from './trust_logos/itz.svg'
import sslLogo from './trust_logos/ssl_logo.png'
import paypalLogo from './trust_logos/paypal.svg'
import paydirektLogo from './trust_logos/paydirekt.svg'

export const TrustLogos = connect(({formik}) => {
  return <div className='flex my-3 space-x-3 desktop:space-x-4'>
    <img src={itzLogo} className='h-9' alt='' />
    <SSLLogo heightClassName='h-9' />
    <PaymentMethodLogo />
  </div>
})

export const SSLLogo = ({heightClassName}) =>
  <Popover
    trigger={<img src={sslLogo} className={heightClassName} alt='' />} popover={ I18n.t('donate.trust_logos.ssl_popover') }
  />

const PaymentMethodLogo = connect(({formik}) => {
  const paymentMethod = formik.values.payment_method
  let logo
  if (paymentMethod === 'paypal') {
    logo = paypalLogo
  } else if (paymentMethod === 'paydirekt') {
    logo = paydirektLogo
  }
  return logo ? <img src={logo} className='h-9' alt='' /> : null
})
